import { Col, Flex, message, Row } from "antd";
import { SmsTemplateFormCard } from "./components/SmsTemplateForm";
import { useMutation } from "@tanstack/react-query";
import { SmsTemplate } from "@rumble-it/common-lib/types/models/SmsTemplate.interface";
import { createSmsTemplate } from "../../../lib/api/resources/sms";
import { useNavigate } from "react-router-dom";

export const SmsTemplateCreate = () => {
  const navigate = useNavigate();

  const createSmsTemplateMutation = useMutation({
    mutationFn: (data: SmsTemplate) => createSmsTemplate(data),
    onSuccess: () => {
      navigate("/sms-templates");
      message.success("SMS Template succesvol aangemaakt");
    },
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <SmsTemplateFormCard mutation={createSmsTemplateMutation} />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
